import React, { useEffect } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import useAnimateScroll from '../../hooks/useAnimateScroll';

const StepNav = ({ rawSteps, reservation }) => {
  const stepNavRef = React.createRef();
  const { startElementAnimation } = useAnimateScroll();
  const { items: steps, active: activeStep } = rawSteps;
  const isPreOrderCompleted = get(reservation, 'isPreOrderCompleted', false);

  useEffect(() => {
    if (!isPreOrderCompleted && stepNavRef.current && activeStep) {
      const stepBarEl = stepNavRef.current.querySelector('.step-nav__bar');
      const fullWidth = stepBarEl.offsetWidth;
      const scrollWidth = stepBarEl.scrollWidth;

      const currentStepLinkWidth = stepNavRef.current.querySelector(
        `.step-nav__bar div:nth-child(${activeStep.index})`
      ).offsetWidth;

      const leftScreenOffset = (fullWidth - currentStepLinkWidth) / 2;
      let leftSiblingWidth = 0;

      steps
        .map(({ index }) => index)
        .filter((stepIndex) => stepIndex < activeStep.index)
        .forEach(
          (index) => {
            leftSiblingWidth += stepNavRef.current.querySelector(
              `.step-nav__outer:nth-child(${index})`
            ).offsetWidth;
          },
          [steps]
        );

      const scrollDistance = leftSiblingWidth - leftScreenOffset;
      const availableScroll = scrollWidth - fullWidth;
      const currentPos = stepBarEl.scrollLeft;
      let scrollDiff = scrollDistance - currentPos;
      if (scrollDistance > availableScroll) {
        scrollDiff = availableScroll - currentPos;
      }
      if (scrollDistance < 0) {
        scrollDiff = 0 - currentPos;
      }
      startElementAnimation(stepBarEl, scrollDiff);
    }
  }, [activeStep]);
  const links = steps.map((step) => {
    const { active, key, path, label } = step;
    const relativePath = path.charAt(0) === '/' ? path.substr(1) : path;
    const stepClassName = `step-nav__step ${
      active ? 'step-nav__step--active' : ''
    }`;
    const stepClassNameOuter = `step-nav__outer ${
      active ? 'step-nav__outer--active' : ''
    }`;
    const linkClassName = `progress-nav__link stat-button-link ${
      active ? 'step-nav__link--active' : ''
    }`;
    const stepClassNameText = `step-nav__text ${
      active ? 'step-nav__text--active' : ''
    }`;

    return (
      <div key={key} className={stepClassNameOuter}>
        <div className={stepClassName}>
          <Link
            id={`progress-nav__${key}`}
            to={relativePath}
            className={linkClassName}
            data-dtm="step nav">
            <span title={label} className={stepClassNameText}>
              {label}
            </span>
          </Link>
        </div>
      </div>
    );
  });

  return (
    <>
      {!isPreOrderCompleted && (
        <div className="step-nav-container">
          <div ref={stepNavRef} className="step-nav">
            <nav className="step-nav__bar">{links}</nav>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { reservation } = state;

  return {
    reservation,
  };
};

export default connect(mapStateToProps)(StepNav);
